import { flow } from 'mobx';


import api from '../services/api';

import getShareURL from '../helpers/getShareUrl';

import analyticsStore from './analytics';

class Social {
    
    share = flow(function*(platform, score) {
        try {
            const data = yield api.Common.share(score);
            yield this.onShare(Object.assign(data, {platform}));
        } catch (e) {
            this.error = e.message;
        } finally {
            this.loading = false;
        }
    });
    
    shareWebsite = flow(function*(platform) {
        try {
            yield this.onShareWebsite({
                url: window.location.origin,
                hashtags: "#deadlyarcade",
                text: "Deadly Arcade",
                platform: platform
            });
        } catch (e) {
            this.error = e.message;
        } finally {
            this.loading = false;
        }
    });


    onShare(data) {
        try {
            if (!data.url) {
                data.url = 'https://deadlyarcade.dev.pushstart.com.br/'
            }

            const share = getShareURL(data);

            analyticsStore.event({
                category: 'Social Share',
                action: data.platform,
                value: data.score,
            });

            const popup = window.open(share, '_blank');
            
            if(!popup || popup.closed || typeof popup.closed === 'undefined') { 
                try {
                    window.top.location = share;
                } catch (e) {} 
            }
        } catch(e) {}
    }

    onShareWebsite(data) {
        try {
            if (!data.url || data.url.indexOf('localhost') >= 0) {
                data.url = 'https://deadlyarcade.dev.pushstart.com.br'
            }
    
            const share = getShareURL(data);
    
            analyticsStore.event({
                category: 'Social Share',
                action: data.platform,
                label: 'Website',
            });
    
            const popup = window.open(share, '_blank');
            
            if(!popup || popup.closed || typeof popup.closed === 'undefined') { 
                try {
                    window.top.location = share;
                } catch (e) {} 
            }
        } catch(e) {}

    }
}

export default new Social();
